import React from 'react';
import { MapPinned, BellRing, Layers, TrendingUp, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const benefits = [
  {
    icon: MapPinned,
    title: 'Local requirements, mapped and extracted.',
    description:
      'Requirements for sales, design, engineering, permitting, interconnection, and inspection. Fordje reads the 80–250+ documents a city scatters across websites and extracts what applies to your project, cited to source document and section. Verify anything.',
  },
  {
    icon: BellRing,
    title: 'Alerts when requirements change.',
    description:
      'No more submit and pray. Fordje keeps every requirement attached to your active projects under watch and lets you know when it changes.',
  },
  {
    icon: Layers,
    title: 'Jurisdictional conflict, resolved.',
    description:
      'State code, county overlay, city amendment, utility rule. We map the Authority Having Jurisdiction (AHJ) hierarchy and pull the right information for you.',
  },
  {
    icon: TrendingUp,
    title: 'Get ahead of changes.',
    description:
      'We track approved changes on the state and federal level so you can make plans ahead of time.',
  },
];

const BenefitsSection = () => {
  return (
    <section className="py-16 md:py-24 bg-background border-y border-border">
      <div className="container-custom">
        <div className="max-w-6xl mx-auto">
          <h2 className="mb-14 animate-fade-in text-center max-w-3xl mx-auto">
            Everything you need, <span className="gradient-text">before you need it.</span>
          </h2>

          <div className="grid grid-cols-1 gap-4 max-w-3xl mx-auto">
            {benefits.map((b, i) => {
              const Icon = b.icon;
              return (
                <div
                  key={i}
                  className="bg-card rounded-xl border p-5 lg:p-5 shadow-sm hover:shadow-md transition-shadow animate-fade-in flex"
                  style={{ animationDelay: `${0.05 + i * 0.06}s` }}
                >
                  <div className="flex items-start gap-5">
                    <div className="rounded-lg bg-primary/10 p-3 flex-shrink-0">
                      <Icon className="h-5 w-5 text-primary" />
                    </div>
                    <div>
                      <h3 className="text-lg md:text-xl font-semibold mb-2 text-foreground">
                        {b.title}
                      </h3>
                      <p className="text-muted-foreground leading-relaxed">{b.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-12 md:mt-14 animate-fade-in text-center">
            <p className="text-2xl md:text-3xl font-medium text-foreground leading-snug">
              <span className="text-primary">National footprint.</span> Coverage where you build.
            </p>
            <div className="mt-8">
              <Link to="/product">
                <Button variant="outline" size="lg" className="text-base px-6 py-5 border-primary text-primary hover:bg-primary hover:text-primary-foreground">
                  Explore the product <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
